import { useAppDispatch } from "../../../../../redux/hooks";
import {
  fetchDeleteVerificationZone,
  fetchUnlockZone,
  getPrintVerificationZone,
} from "../../../../../redux/api/picking.api";

import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import { pickingRoutes } from "../../../../../router/routesConstants";
import { VerificationZonesListInterface } from "../../../../../redux/interfaces/picking.interface";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";

function VerificationZonesActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: VerificationZonesListInterface;
}) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const { idZona, deleted } = crudData;

  const handleActivateCell = () => {
    dispatch(
      fetchUnlockZone({
        idZona: idZona,
      }),
    );
    return;
  };

  const handleActivateOrDeactivateVerificationZone = () => {
    dispatch(
      fetchDeleteVerificationZone({
        idZona: idZona,
      }),
    );
  };

  const goToUpdateVerificationZone = () => {
    if (idZona) {
      return `${itemId}/${pickingRoutes.editVerificationZone}?idZona=${idZona}`;
    }
  };

  const handleDownloadZoneBarcode = () => {
    dispatch(
      getPrintVerificationZone({
        idZona: idZona,
      }),
    );
  };

  const items: ActionMenuItem[] = [
    {
      id: "edit-zone",
      label: "Editeaza zona",
      icon: "EDIT",
      tooltip:
        "Deschide configurarea adreselor IP si porturilor imprimantelor zonei.",
      hidden: !isAuthorized(userRoles.EDIT_VERIFICATION_ZONE),
      navigate: goToUpdateVerificationZone(),
    },
    {
      id: "print-barcode",
      label: "Descarca codul de bare",
      icon: "DOWNLOAD",
      kind: "download",
      tooltip: "Descarca PDF-ul cu codul de bare al zonei dupa confirmare.",
      withConfirmationModal: {
        modalTitle: `Doriti sa tipariti codul de bare pentru zona de verificare curenta?`,
        modalLeftButtonVariant: "outlined",
        modalRightButtonOnClick: handleDownloadZoneBarcode,
      },
    },
    {
      id: "toggle-zone",
      dividerBefore: true,
      label: !deleted ? "Dezactiveaza zona" : "Activeaza zona",
      icon: "ACTIVATE",
      tooltip: !deleted
        ? "Dezactiveaza aceasta zona de verificare dupa confirmare."
        : "Activeaza aceasta zona de verificare dupa confirmare.",
      color: !deleted ? "error" : "success",
      withConfirmationModal: {
        modalLeftButtonVariant: "outlined",
        modalTitle: `Doriti sa ${!deleted ? "dezactivati" : "activati"} zona ${
          crudData.codZona
        }?`,
        modalRightButtonOnClick: handleActivateOrDeactivateVerificationZone,
      },
    },
    {
      id: "unlock-zone",
      label: "Deblocheaza zona",
      icon: "LOCK_OPEN",
      tooltip: !crudData.status
        ? "Zona nu este blocata."
        : "Elibereaza zona dupa confirmare, daca nu mai are o comanda in verificare.",
      disabled: !crudData.status,
      color: "success",
      withConfirmationModal: {
        modalLeftButtonVariant: "outlined",
        modalTitle: `Doriti sa deblocati zona ${crudData.codZona}?`,
        modalRightButtonOnClick: handleActivateCell,
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={`Zona ${crudData.codZona}`}
      ariaLabel={`Actiuni pentru zona ${crudData.codZona}`}
    />
  );
}

export default VerificationZonesActionButton;
